import { Box } from "@mui/material";
import ReactApexChart from "react-apexcharts";

import useDataChart from "./useDataChart";
import useOptionsChart from "./useOptionsChart";

// ----------------------------------------------------------------------

export const ConnectionsByMonthChart = () => {
	const { options } = useOptionsChart();
	const { series } = useDataChart();

	return (
		<Box sx={{ mx: { sm: 1.5, xs: 0 }, mt: 0.5 }}>
			<ReactApexChart height={365} options={options} series={series} type='bar' />
		</Box>
	);
};

export default ConnectionsByMonthChart;
